
/* injects from baggage-loader */

'use strict';

import moment from 'moment';

export default class ProjectController {

	constructor($log, $timeout, $state, User, Alerts) {
		'ngInject';

		this.$log = $log;
		this.$timeout = $timeout;
		this.$state = $state;
		this.User = User;
		this.Alerts = Alerts;

		// Smallest amount allowed to invest
		this.default_investment_min = 500;

		// Initalize comments
		this.comments = [];
		this.topLevelComments = [];
		this.showCommentBox = false;

		// Initialize documents
		this.documents = [];

		// Admin stuff
		this.isEditingProject = false;

	}

	$onInit() {
		this.$log.log('Project:', this.project);
		this.$log.log(this.comments);
		this.$log.log(this.documents);

		// Find all top level comments (comments without parents)
		this.topLevelComments = this.comments.filter(comment => typeof comment.get('parent') === 'undefined');

	}


	/**
	 * Returns the number of days remianing until the end of the raise
	 * @param {Object} project 
	 */
	daysRemaining(project) {
		let days = moment(project.get('end_date')).diff(moment(), 'days')
		return days > 0 ? days : 0;
	}


	/**
	 * Show the comment box
	 */
	revealCommentBox() {
		this.showCommentBox = true;
	}

	/**
	 * Method called after a top level comment is posted
	 */
	commentPosted() {
		// Display local alert
		this.Alerts.setLocal({
			msg: 'Comment posted successfully',
			type: 'success'
		});
	}


	/**
	 * Returns true when the current user is the owner of the project
	 */
	isProjectOwner() {
		let currentUser = this.User.getCurrent();
		let ACL = this.project.getACL();
		if (currentUser && ACL) {
			return ACL.getWriteAccess(currentUser.id);
		}
	}


	/**
	 * Toggles the project into editing mode
	 */
	toggleEditing() {
		if (this.isProjectOwner() === true) {
			if (this.isEditingProject === true) {
				if (this.project.dirty() === true) {
					alert('Please "Discard" or "Save" changes before leaving editing mode');
					return false;
				}
				this.isEditingProject = false;
			} else {
				this.isEditingProject = true;
			}
		}
	}


	newSection() {
		this.project.infoSections.push({
			title: '',
			body: ''
		});
	}

	deleteInfoSection(index) {
		this.$log.log('Delete section index:', index);
		this.$log.log(this.project.infoSections[index]);
		this.project.infoSections.splice(index, 1);
	}


	/**
	 * Discards any changes to the object
	 */
	discardChanges() {
		// this.project.revert();
		// this.$timeout(() => {
		// 	this.$log.log('Cleared changes')
		// });
		this.$state.reload();
	}


	/**
	 * Save any changes to the object to the server
	 */
	saveChanges() {
		this.project.save()
			.then(_project => {
				this.$log.log('Saved changes');
				this.$state.reload();
			});
	}

}



// WEBPACK FOOTER //
// ./src/app/pages/project/project.controller.js